define('v3/Common/Services/Backend/learningObjectiveStatusBackend',[
	'jquery',
	'lodash',
	'BackendBase'
], function ($, _, BackendBase) {
	function LearningObjectiveStatusBackend () {
		BackendBase.call(this);
	}

	function getLearningObjectiveStatusBaseUrl (classId, subjectGroupId) {
		return Settings.learningObjectiveStatusApi + '/LearningObjectiveStatus/' + classId + '/' + subjectGroupId;
	}

	function successHandler (data) {
		return data;
	}

	function makeApiCall (url, data, ignoreErrors) {
		return BackendBase.prototype._postJsonApiWithJwtAuthorization(
			url,
			data,
			{ showError: ignoreErrors }
		).then(
			successHandler,
			function (err) {
				if (ignoreErrors) {
					return $.Deferred().resolve({ hasErrors: true });
				}
				throw err;
			}
		);
	}

	LearningObjectiveStatusBackend.prototype = $.extend({}, BackendBase.prototype);
	$.extend(LearningObjectiveStatusBackend.prototype, {
		getLearningObjectiveStatusesForPupil: function (classId, subjectGroupId, pupilId, learningObjectiveIds, ignoreErrors) {
			if (!learningObjectiveIds || !learningObjectiveIds.length) {
				return $.Deferred().resolve([]);
			}

			return makeApiCall(
				getLearningObjectiveStatusBaseUrl(classId, subjectGroupId) + '/user/' + pupilId,
				{ learningObjectiveIds: this.toNumberArray(learningObjectiveIds) },
				ignoreErrors
			);
		},
		getPupilsStatusesForLearningObjective: function (classId, subjectGroupId, learningObjectiveId, pupilIds, ignoreErrors) {
			if (!pupilIds || !pupilIds.length) {
				return $.Deferred().resolve([]);
			}

			return makeApiCall(
				getLearningObjectiveStatusBaseUrl(classId, subjectGroupId) + '/learningObjective/' + learningObjectiveId,
				{ userIds: this.toNumberArray(pupilIds) },
				ignoreErrors
			);
		},
		getPupilsWithStatusCountsForLearningObjective: function (classId, subjectGroupId, learningObjectiveId, pupilIds, ignoreErrors) {
			if (!pupilIds || !pupilIds.length) {
				return $.Deferred().resolve([]);
			}

			return makeApiCall(
				getLearningObjectiveStatusBaseUrl(classId, subjectGroupId) + '/learningObjective/' + learningObjectiveId + '/Count',
				{ userIds: this.toNumberArray(pupilIds) },
				ignoreErrors
			);
		},
		hasEnoughAnswersForLearningObjectiveStatus: function (classId, subjectGroupId, learningObjectiveIds, ignoreErrors) {
			if (!learningObjectiveIds || !learningObjectiveIds.length) {
				return $.Deferred().resolve([]);
			}

			return makeApiCall(
				'/api/' + classId + '/v4/SubjectGroup/' + subjectGroupId + '/HasEnoughAnswersForLearningObjectiveStatus/',
				learningObjectiveIds,
				ignoreErrors
			);
		},
		getLoStatusCountForLoIds: function (classId, subjectGroupId, learningObjectiveIds, pupilIds, ignoreErrors) {
			if (!learningObjectiveIds || !learningObjectiveIds.length || !pupilIds || !pupilIds.length) {
				return $.Deferred().resolve([]);
			}

			return makeApiCall(
				getLearningObjectiveStatusBaseUrl(classId, subjectGroupId) + '/learningObjectivesCount',
				{ userIds: this.toNumberArray(pupilIds), learningObjectiveIds: this.toNumberArray(learningObjectiveIds) },
				ignoreErrors
			);
		},
		toNumberArray: function (ids) {
			return _.map(ids, function (id) {
				return Number(id);
			});
		}
	});

	return new LearningObjectiveStatusBackend();
});

